import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseFestivalManagment() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      startDate: isEmpty(state.startDate),
      endDate: isEmpty(state.endDate),
    };

    setter(errorState);

    if (errorState.title || errorState.startDate || errorState.endDate) {
      enqueueSnackbar("لطفا اطلاعات جشنواره را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getFestivalList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Festivals?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getFestivalByID = (id, callback) => {
    MyAxios.get(`Admin_Festivals/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getFestivalDiscountsByID = (id, myPc, search, callback) => {
    MyAxios.get(`Admin_Festivals/discounts/${id}?w=${search}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateFestival = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.put(`Admin_Festivals`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت آپدیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  const createFestival = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Festivals`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addFestivalDiscount = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Festivals/discounts`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const startFestival = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Festivals/start`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const finishFestival = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Festivals/finish`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteFestivalList = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Festivals`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("جشنواره با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  const deleteFestivalDiscount = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Festivals/discounts`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("تخفیف با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };
  return {
    validate,
    getFestivalList,
    getFestivalByID,
    updateFestival,
    createFestival,
    deleteFestivalList,
    getFestivalDiscountsByID,
    deleteFestivalDiscount,
    addFestivalDiscount,
    startFestival,
    finishFestival,
  };
}
